import { supabase } from "./supabase";

export class BaseApi<T> {
  constructor(private table: string) {}

  async getById(id: string) {
    const { data, error } = await supabase
      .from<T>(this.table)
      .select("*")
      .eq("uuid", id)
      .maybeSingle();
    if (error) throw error;
    return data;
  }

  async getAll() {
    const { data, error } = await supabase.from<T>(this.table).select("*");
    if (error) throw error;
    return data;
  }

  async filter(
    filter: Record<string, any>,
    sort?: { column: string; ascending?: boolean }
  ) {
    let query = supabase.from<T>(this.table).select("*");
    Object.entries(filter).forEach(([key, value]) => {
      query = query.eq(key, value);
    });
    if (sort) {
      query = query.order(sort.column, { ascending: sort.ascending ?? true });
    }
    const { data, error } = await query;
    if (error) throw error;
    return data;
  }

  async insert(payload: Partial<T>) {
    const { data, error } = await supabase
      .from<T>(this.table)
      .insert(payload)
      .select()
      .single();
    if (error) throw error;
    return data;
  }

  async update(id: string, payload: Partial<T>) {
    const { data, error } = await supabase
      .from<T>(this.table)
      .update(payload)
      .eq("uuid", id)
      .select()
      .single();
    if (error) throw error;
    return data;
  }

  async delete(id: string) {
    const { error } = await supabase
      .from<T>(this.table)
      .delete()
      .eq("uuid", id);
    if (error) throw error;
    return true;
  }

  async upsert(payload: Partial<T>) {
    const { data, error } = await supabase
      .from<T>(this.table)
      .upsert(payload)
      .select()
      .single();
    if (error) throw error;
    return data;
  }

  subscribe(callback: (payload: any) => void) {
    return supabase
      .channel(this.table)
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: this.table },
        callback
      )
      .subscribe();
  }

  subscribeById(id: string, callback: (payload: any) => void) {
    return supabase
      .channel(`${this.table}-by-id-${id}`)
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: this.table,
          filter: `uuid=eq.${id}`,
        },
        callback
      )
      .subscribe();
  }
}
